import styled from 'styled-components';

export const Checkbox = styled.input.attrs({
  className: 'Checkbox',
  type: 'checkbox',
})`
  margin: 0 2px;
  cursor: pointer;
  accent-color: maroon;
`;

interface PhaseOptionContainerProps {
  $isSelected: boolean;
}

export const PhaseOptionContainer = styled.div.attrs({
  className: 'PhaseOptionContainer',
})<PhaseOptionContainerProps>(
  ({ $isSelected }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${$isSelected ? 'lightpink' : 'none'};
    &:hover {
      background: ${$isSelected ? 'pink' : 'lightgray'};
    }
  `
);
